import { CellProps, Renderer } from 'react-table';
import { dateUtils } from 'utils/date-utils';

const DateTimeRenderer: Renderer<CellProps<Record<string, any>>> = ({
  value,
}) => <>{dateUtils.shortDateTimeFormat(value)}</>;
export default DateTimeRenderer;
